import utils from '@/js/utils'

// 1 MU = 120 seconds
// Large: cut 20min (10 MU), finish 15min (7.5 MU), assembly 4min (2 MU)
// Small: cut 15min (7.5 MU), finish 11.25min (5.625 MU), assembly 3min (1.5 MU)

const muValues = {
  large: { cut: 10, finish: 7.5, assemble: 2 },
  small: { cut: 7.5, finish: 5.625, assemble: 1.5 }
}

export default {
  get(spiceRacks, materials, taskType) {
    let mu = 0
    if (!spiceRacks) return mu

    for (const spiceRack of spiceRacks) {
      // check incomplete
      if (!spiceRack.size || !spiceRack.dowel || !spiceRack.materialType || !spiceRack.frame) continue

      const size = spiceRack.size === 'large' ? 'large' : 'small'
      mu += muValues[size][taskType] || 0
    }

    return utils.toFixedNumber(mu, 2)
  }
}
